// BNB
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// HODL
export const DEFAULT_OUTPUT_CURRENCY = '0x32b407ee915432be6d3f168bc1eff2a6f8b2034c'
